"use client";

import { memo } from "react";
import styles from "./ExpressDeliveryFilter.module.scss";
import Text from "@components/atoms/Text";
import ToggleSwitch from "@components/atoms/ToggleSwitch";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { ExpressDeliveryFilterProps } from "@interfaces/filter.types";

const ExpressDeliveryFilter = memo(
  ({ isEnabled, onToggle }: ExpressDeliveryFilterProps) => {
    return (
      <div className={styles.container}>
        <div className={styles.labelContainer}>
          <Image
            src={`${assetLoader()}/icons/thunder.svg`}
            alt="Express Delivery"
            width={16}
            height={16}
            loading="lazy"
          />
          <Text className={styles.label}>Express Delivery</Text>
        </div>
        <ToggleSwitch isOn={isEnabled} onToggle={onToggle} />
      </div>
    );
  }
);

ExpressDeliveryFilter.displayName = "ExpressDeliveryFilter";

export default ExpressDeliveryFilter;
